const findResource = (id, resourceArray) => {
    if (!resourceArray.length) return false;
    const found = resourceArray.find((resource) => resource.id === id);
    return found ? true : false;
};
export default findResource;
